import { Spinner } from '@fluentui/react-components';
import { createFileRoute } from '@tanstack/react-router';
import { lazy, Suspense } from 'react';

const CleanupPage = lazy(() =>
  import('../../pages/admin/cleanup/CleanupPage').then((m) => ({
    default: m.CleanupPage,
  })),
);

export const Route = createFileRoute('/admin/cleanup')({
  component: () => (
    <Suspense
      fallback={
        <Spinner
          style={{
            position: 'absolute',
            top: '25%',
            left: '50%',
            transform: 'translateX(-50%)',
          }}
        />
      }
    >
      <CleanupPage />
    </Suspense>
  ),
});
